var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"m-3"},[_c('p',[_vm._v(" I understand I must give notice of my intention to proceed to each other party. To give notice, they must be served or provided with a copy of the filed Notice of Intention to Proceed. ")])])])
}]

export { render, staticRenderFns }